import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FeatureFlagService } from 'src/app/core/services/feature-flag.service';
import { EFeatureFlag } from 'src/app/core/services/feature-flags-consts';
import { EUserRole } from 'src/app/project/modules/share/share-utils/user-roles';
import { TShare } from 'src/app/project/modules/share/share.model';
import { EditAccountUserModalDataService } from '../../edit-account-user-modal-data.service';

@Component({
  selector: 'pp-account-user-modal-shares-list-individual-share',
  templateUrl: './account-user-modal-shares-list-individual-share.component.html',
  styleUrl: './account-user-modal-shares-list-individual-share.component.scss',
  standalone: false,
})
export class AccountUserModalSharesListIndividualShareComponent implements OnInit {
  @Input() ppShare: TShare;
  @Input() ppHasError: boolean;
  @Output() ppShowCustomFieldsTable = new EventEmitter<void>();
  @Output() ppShareChange = new EventEmitter<TShare>();

  share: TShare;
  EUserRole = EUserRole;

  relatedPointsFlagEnabled: boolean;

  private readonly disabledForAdminRoles: EUserRole[] = [
    EUserRole.SITE_ADMIN,
    EUserRole.ACCOUNT_ADMIN,
  ];

  private readonly disabledForAdminAndLimitedRoles: EUserRole[] = [
    EUserRole.SITE_ADMIN,
    EUserRole.ACCOUNT_ADMIN,
    EUserRole.LIMITED,
  ];

  get isDisabledForAdmin(): boolean {
    return this.disabledForAdminRoles.includes(this.share?.shareOption);
  }

  get isDisabledForAdminAndLimited(): boolean {
    return this.disabledForAdminAndLimitedRoles.includes(this.share?.shareOption);
  }

  constructor(
    private editAccountUserModalDataService: EditAccountUserModalDataService,
    private featureFlagService: FeatureFlagService,
  ) {}

  ngOnChanges(): void {
    this.share = this.ppShare;

    this.editAccountUserModalDataService.setIndividualShare(this.share);

    this.relatedPointsFlagEnabled = this.featureFlagService.getFlag(EFeatureFlag.RELATED_POINTS);

    this.featureFlagService.flagsChange$.subscribe(() => {
      this.relatedPointsFlagEnabled = this.featureFlagService.getFlag(EFeatureFlag.RELATED_POINTS);
    });
  }

  ngOnInit(): void {
    this.editAccountUserModalDataService.sharesBulkChange$.subscribe(() => {
      this.share = this.editAccountUserModalDataService
        .getIndividualShares()
        .find((share) => share?.shareId === this.ppShare?.shareId);
      this.updateShare(false);
    });

    this.share = this.ppShare;
    this.editAccountUserModalDataService.setIndividualShare(this.share);
  }

  showCustomFieldsTable(): void {
    this.ppShowCustomFieldsTable.emit();
  }

  updateShare(emit: boolean = true): void {
    this.ppShareChange.emit(this.share);
    this.editAccountUserModalDataService.setIndividualShare(this.share);

    if (emit) {
      this.editAccountUserModalDataService.emitSharesChange();
    }
  }
}
